export const AGGREGATIONS = {
  DAILY: 'DAILY',
  HOURLY: 'HOURLY'
};
